import { create } from "zustand";

const initialState = {
  userDropdownActive: false,
};

const useMainSidebarStore = create((set) => ({
  ...initialState,
  setUserDropdownActive: (payload) => {
    set({ userDropdownActive: payload });
  },
  toggleUserDropdown: () => {
    set((state) => ({ userDropdownActive: !state.userDropdownActive }));
  },
}));

export default useMainSidebarStore;
